import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { getAuthForPath, isParticipantSession } from '../util/authSession';
import { lerPermissoes, limparPermissoes, salvarPermissoes, temAcesso, temPermissao } from '../util/acessoPermissao';

const VAZIAS = { codigos: [], rotas: [] };
const PermissoesContext = createContext(null);

/**
 * As permissões das telas restritas do usuário logado, num lugar só: uma busca ao abrir o app e outra no login. O
 * localStorage guarda o que veio por último, para a primeira tela não esperar a API. O que o admin mudar vale no
 * próximo login ou ao recarregar a página.
 */
export function PermissoesProvider({ children }) {
    // null: nada guardado neste navegador e a API ainda não respondeu.
    const [permissoes, setPermissoes] = useState(lerPermissoes);

    const recarregar = useCallback(() => {
        const { token } = getAuthForPath();
        // Sem sessão interna não há o que buscar: a PrivateRoute cuida do login.
        if (!token || isParticipantSession()) {
            setPermissoes(p => p ?? VAZIAS);
            return Promise.resolve();
        }
        return api({ method: 'get', action: '/acesso/minhas', token })
            .then(res => {
                salvarPermissoes(res.data.data);
                setPermissoes(res.data.data);
            })
            // Falhou: fica o que estava guardado.
            .catch(() => setPermissoes(p => p ?? VAZIAS));
    }, []);

    // O login troca o usuário: as permissões do anterior não passam para este.
    const limpar = useCallback(() => {
        limparPermissoes();
        setPermissoes(null);
    }, []);

    useEffect(() => { recarregar(); }, [recarregar]);

    return (
        <PermissoesContext.Provider value={{
            carregadas: permissoes !== null,
            recarregar,
            limpar,
            temAcesso: (to) => temAcesso(to, permissoes),
            temPermissao: (codigo) => temPermissao(codigo, permissoes),
        }}>
            {children}
        </PermissoesContext.Provider>
    );
}

export const usePermissoes = () => useContext(PermissoesContext);
